import { Command } from '../../_base/actionBus/Command';

export class RegisterDeviceToken extends Command {}
